import styled from '@emotion/styled';

export const IconButton = styled.button`
  border: none;
  background: none;
  outline: none;
`;
